const scenes = {
  LIVESTATUS: 'live_tracker',
  SUCCESS: 'success',
  FROM_HISTORY: 'history',
  LOBBY: 'lobby',
}

export default scenes
